import { FC } from 'react';

type Props = {
	className?: string;
};

const MoneyReceiveCircleIconSolid: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='#2B2B2B'
			stroke='none'
			className={className}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M2 10.0002C2 5.5818 5.5818 2 10.0002 2C10.5472 2 11.0821 2.055 11.5994 2.16003C11.9931 2.23993 12.2474 2.62382 12.1675 3.01746C12.0875 3.4111 11.7037 3.66543 11.3101 3.58552C10.8875 3.49973 10.4494 3.45457 10.0002 3.45457C6.38513 3.45457 3.45457 6.38513 3.45457 10.0002C3.45457 13.6151 6.38514 16.5457 10.0002 16.5457C13.6151 16.5457 16.5457 13.6151 16.5457 10.0002C16.5457 9.55092 16.5006 9.11287 16.4148 8.69017C16.335 8.29654 16.5893 7.91269 16.983 7.83282C17.3766 7.75296 17.7605 8.00733 17.8403 8.40098C17.9453 8.91825 18.0003 9.45317 18.0003 10.0002C18.0003 14.4185 14.4185 18.0003 10.0002 18.0003C5.58179 18.0003 2 14.4185 2 10.0002Z'
				fill='inherit'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M9.99827 6.36377C10.3999 6.36377 10.7256 6.68939 10.7256 7.09106V7.19396C11.2859 7.35646 11.7798 7.70911 12.028 8.23559C12.1992 8.59894 12.0435 9.03226 11.6801 9.20354C11.3168 9.37474 10.8835 9.21903 10.7122 8.85567C10.665 8.75567 10.4353 8.54563 9.99827 8.54563C9.73877 8.54563 9.53179 8.62542 9.40611 8.71967C9.28065 8.81378 9.27098 8.88826 9.27098 8.90928C9.27098 8.93029 9.28065 9.00477 9.40611 9.09888C9.53179 9.19314 9.73877 9.27292 9.99827 9.27292C10.5421 9.27292 11.0624 9.43736 11.4632 9.73787C11.8642 10.0387 12.1801 10.5097 12.1801 11.0911C12.1801 11.6726 11.8642 12.1436 11.4632 12.4444C11.247 12.6064 10.9962 12.729 10.7256 12.8074V12.9094C10.7256 13.311 10.3999 13.6366 9.99827 13.6366C9.59659 13.6366 9.27098 13.311 9.27098 12.9094V12.8064C8.71068 12.644 8.21668 12.2913 7.96857 11.7648C7.79734 11.4015 7.95308 10.9682 8.31642 10.7969C8.67977 10.6257 9.11309 10.7814 9.28436 11.1447C9.33149 11.2447 9.56124 11.4548 9.99827 11.4548C10.2578 11.4548 10.4648 11.375 10.5904 11.2807C10.7159 11.1866 10.7256 11.1122 10.7256 11.0911C10.7256 11.0701 10.7159 10.9956 10.5904 10.9015C10.4648 10.8073 10.2578 10.7275 9.99827 10.7275C9.45448 10.7275 8.9341 10.5631 8.53336 10.2625C8.13236 9.96173 7.81641 9.49074 7.81641 8.90928C7.81641 8.32778 8.13236 7.85679 8.53336 7.55604C8.74952 7.39394 9.00036 7.27145 9.27098 7.19299V7.09106C9.27098 6.68939 9.59659 6.36377 9.99827 6.36377Z'
				fill='inherit'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M16.8549 6.64204C16.7423 6.91382 16.4771 7.09101 16.1829 7.09101H13.6374C13.2358 7.09101 12.9102 6.7654 12.9102 6.36373V3.81822C12.9102 3.52406 13.0873 3.25886 13.3591 3.14629C13.6309 3.03372 13.9437 3.09595 14.1517 3.30395L14.9102 4.06243L16.7596 2.21302C17.0436 1.92899 17.5041 1.92899 17.7881 2.21302C18.0722 2.49704 18.0722 2.95753 17.7881 3.24156L15.9387 5.09097L16.6972 5.84945C16.9052 6.05746 16.9675 6.37028 16.8549 6.64204Z'
				fill='inherit'
			/>
		</svg>
	);
};

export default MoneyReceiveCircleIconSolid;
